<template lang="pug">
  v-container(fill-height fluid pa-0 ma-0)
    v-row(justify="center")
      v-col(cols="4")
        v-row(justify="center")
          v-progress-circular(size="50" indeterminate)
        v-row.mt-10(justify="center")
          span Validando autorização
        v-row.version(justify="center")
          span v{{$store.getters.appVersion}}
</template>

<script>
export default {
  name: "LoginView",
  data() {
    return {};
  },
  computed: {},
  created() {},
  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="sass">

.version
  margin-top: 24px
</style>
